import { useState } from "react";
import BasicModal from "src/features/student-attendance/components/modal";
import BusEditForm from "./bus-edit-form";
import { toast } from "react-toastify";
import { usePostBusMutation } from "src/services/react-query-apis/post-bus";

const BusAddButton = ({ onSuccess }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleCancel = () => {
    setOpenModal(false);
  };

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      setOpenModal(false);
      onSuccess(data.data.id);
    },
  };

  const postBusMutation = usePostBusMutation({
    mutationConfig,
  });

  return (
    <>
      <button
        className="btn btn-sm btn-outline-success px-3 ml-auto"
        type="button"
        title="バス追加"
        onClick={() => {
          setOpenModal(true);
        }}
      >
        <i className="fas fa-plus fa-fw"></i>
      </button>
      {/* Add Modal */}
      <BasicModal
        title="バス追加"
        isOpen={openModal}
        onCancel={handleCancel}
        width="50%"
      >
        <BusEditForm
          selectedBus={null}
          onSubmit={postBusMutation.mutate}
          isSubmitting={postBusMutation.isPending}
          onCancel={handleCancel}
        />
      </BasicModal>
    </>
  );
};

export default BusAddButton;
